import Home from "./views/index.vue";
import Ccass from "./views/Ccass.vue";
import Changes from "./views/Changes.vue";
import Detail from "./views/Detail.vue";
import Focus from "./views/Focus.vue";
import Cholding from "./views/Cholding.vue";
import allCcass from "./views/allCcass.vue";
import Cchange from "./views/Cchange.vue";
import Longhu from "./views/longhubang.vue";
import auto_login from "./views/auto_login.vue"
const routers = [
  {
    path: "/",
    name: "home",
    component: Home // 首页好像不用动
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   component: About
  // },
  {
    path: "/xccass/:code", // 完成 === 数据源对比完成
    name: "xccass",
    component: Ccass
  },
  {
    path: "/changes/:code", // 完成
    name: "changes",
    component: Changes
  },
  {
    path: "/details/:code/:cid",
    name: "detail",
    component: Detail
  },
  {
    path: "/concentration/:code", // 👀完成更新
    name: "concentration",
    component: Focus
  },
  {
    path: "/cholding/:ccass_id", // 已经更新接口
    name: "cholding",
    component: Cholding
  },
  {
    path: "/allccass", // 已经更新接口
    name: "allccass",
    component: allCcass
  },
  {
    path: "/Cchange/:ccass_id", // 完成更新
    name: "cchange",
    component: Cchange
  },
  {
    path: "/longhu", // 龙虎榜完成
    name: "longhu",
    component: Longhu
  },
  {
    path: "/auto_login", // 龙虎榜完成
    name: "auto_login",
    component: auto_login
  }
];
export default routers;
